<nav class="navbar sticky-top main-nav p-4">
  <img
    routerLink="/"
    src="/assets/images/smart-menu-logo.svg"
    alt="back"
    class="pointer"
  />
</nav>
